import ActionsForm from '@/shared/mixins/actionsForm'
import templateFilter from './components/templateFilter/templateFilter.vue'
import templateTable from './components/templateTable/templateTable.vue'
import panelByApr from './components/PanelByApr/PanelByApr.vue'
import tabsApr from './components/tabsApr/tabsApr.vue'
// import Tools from '@/components/tools/Tools.js'

export default {
  name: 'aprtemplate',
  components: {templateFilter, templateTable, panelByApr, tabsApr},
  mixins: [ActionsForm],
  data () {
    return {
      details: false,
      aprId: null,
      revisao: null,
      codigo: null,
      statusTemplate: null,
      atualizaAbasRevisao: null,
      clone: {},
      novoTemplateClonado: {}
    }
  },
  methods: {
    detalhesApr (value) {
      this.aprId = value.id
      this.revisao = value.revisao
      this.statusTemplate = value.status
      this.codigo = value.codigoAtividade
      this.details = true
    },
    search (data) {
      this.$refs.tablesearchtemplate.formSearch = data
      this.$refs.tablesearchtemplate.onLoad()
    },
    recarregarTemplateEdicao (value) {
      this.$refs.refPanelByApr.onLoad(value)
    },
    AtualizaAbas (value) {
      this.atualizaAbasRevisao = value
    },
    templateClonado (value) {
      this.novoTemplateClonado = {...value}
      this.detalhesApr(this.novoTemplateClonado)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/templateApr.js